import React from 'react';
import Hero from '../components/Hero';
import StatsStrip from '../components/StatsStrip';
import AboutSection from '../components/AboutSection';
import HowItWorks from '../components/HowItWorks';
import Prizes from '../components/Prizes';
import SubmissionFees from '../components/SubmissionFees';
import Timeline from '../components/Timeline';
import FAQPreview from '../components/FAQPreview';

const Home = () => {
  return (
    <>
      <Hero />
      <StatsStrip />
      <AboutSection />
      <div className="section-divider" />
      <HowItWorks />
      <Prizes />
      <SubmissionFees />
      <Timeline />
      <div className="section-divider" />
      <FAQPreview />
    </>
  );
};

export default Home;
